module.exports = __webpack_public_path__ + "img/laughing.91563701.svg";